import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SharedService } from './service/shared.service';
import { VersionCheckService } from './service/version-check.service';
import { AuthService } from './service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'WebApp';

  ShowNavBar = false;
  showNavTHR = false;

  UserName = '';
  UserNameTHR = '';
  Reportees = '';

  MenuHide = false;
  IsGuestAdmin = false;

  userId = '';
  userIdTHR = '';

  companyId = '';
  companyName = '';
  UserBUHead: any = '';
  UserDeskAdmin: any = '';
  hasHRProfile = false;
  hasBUHR = false;
  hasAccounts = false;
  hasFinance = false;
  hasCFO = false;
  hasDriverManagerInbox = false;
  hasTravelDesk = false;
  hasBUHead = false;
  hasRDH = false;
  hasGDH = false;
  hasGuestAdmin = false;
  hasKOCKPIT = false;
  canManageRsmMaster = false;
  Band = '';

  currentYear = new Date().getFullYear();

  userMenuOpen = false;
  private userMenuHoverCloseTimer: ReturnType<typeof setTimeout> | null = null;

  version = 10;

  subscription: Subscription;
  private navCloseSubscription: Subscription;
  private readonly rsmMasterAllowedTmc = '16268';
  private readonly rsmMasterAllowedSbu = '500';

  /** Hide header on login (and when session is empty). Query params must not leak chrome. */
  get showAppHeader(): boolean {
    const path = (this._router.url || '').split('?')[0];
    if (!path || path === '/') {
      return false;
    }
    const userId = sessionStorage.getItem('userId');
    const fullName = sessionStorage.getItem('FullName');
    return !!(userId && fullName && userId !== 'null' && fullName !== 'null');
  }

  constructor(
    public _router: Router,
    public _sharedSer: SharedService,
    private VCService: VersionCheckService,
    private authService: AuthService
  ) {
    this.Band = sessionStorage.getItem("Band");
  }

  // ================= INIT =================
  ngOnInit(): void {
    this.authService.initSessionTimeout();
    this.loadFromSession();

    this.navCloseSubscription = this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.closeMobileMenu());

    this.subscription = this._sharedSer.getUserData().subscribe(res => {
      this.resetNavbar();

      if (!res || !res.UserData) {
        return;
      }

      const user = res.UserData;
      const roles = user.UserRole || [];

      console.log('User Data from AppComponent:', user);

      for (let i = 0; i < roles.length; i++) {
        if (!roles[i].ACTIVE) {
          continue;
        }

        switch (roles[i].ACCESS_ROLE) {
          case 'HRPROFILE':
            this.hasHRProfile = true;
            break;

          case 'BUHR':
          case 'BHR':
          case 'BU HR':
            this.hasBUHR = true;
            break;

          case 'ACCOUNTS':
            this.hasAccounts = true;
            break;

          case 'FINANCE':
            this.hasFinance = true;
            break;

          case 'CFO':
            this.hasCFO = true;
            break;

          case 'TRAVELDESK':
            this.hasTravelDesk = true;
            break;

          case 'BUHEAD':
            this.hasBUHead = true;
            break;

          case 'GUEST ADMIN':
            this.hasGuestAdmin = true;
            break;
          case 'RDH':
            this.hasRDH = true;
            break;
          case 'GDH':
            this.hasGDH = true;
            break;

          case 'KOCKPIT':
            this.hasKOCKPIT = true;
            break;
        }
      }

      // Tara ISBUHR flag (1 = BU HR)
      if (user.ISBUHR === 1 || user.ISBUHR === '1' || user.ISBUHR === true) {
        this.hasBUHR = true;
        sessionStorage.setItem('ISBUHR', '1');
      } else if (sessionStorage.getItem('ISBUHR') === '1') {
        this.hasBUHR = true;
      } else {
        sessionStorage.setItem('ISBUHR', '0');
      }

      const sbuCode = (user.EmployeeSBUCode || user.SBUCode || sessionStorage.getItem('UserSBUCode') || '').toString().trim();
      if (sbuCode) {
        sessionStorage.setItem('UserSBUCode', sbuCode);
      }

      sessionStorage.setItem(
        'rolesFlags',
        JSON.stringify({
          hasHRProfile: this.hasHRProfile,
          hasBUHR: this.hasBUHR,
          hasAccounts: this.hasAccounts,
          hasFinance: this.hasFinance,
          hasCFO: this.hasCFO,
          hasTravelDesk: this.hasTravelDesk,
          hasBUHead: this.hasBUHead,
          hasRDH: this.hasRDH,
          hasGDH: this.hasGDH,
          hasGuestAdmin: this.hasGuestAdmin,
          hasKOCKPIT: this.hasKOCKPIT
        })
      );

      sessionStorage.setItem('userId', user.TMC);
      sessionStorage.setItem('FullName', user.Full_Name);
      sessionStorage.setItem('UserEmail', user.Company_E_Mail);
      sessionStorage.setItem('IsGuestAdmin', user.IsGuestAdmin ? 'true' : 'false');
      sessionStorage.setItem('LoginFlag', '1');

      this.Band = sessionStorage.getItem('Band');
      console.log(this.Band);

      this.loadFromSession();
    });

  }

  // ================= SESSION HANDLER =================
  loadFromSession(): void {
    this.UserName = sessionStorage.getItem('FullName') || '';
    this.Reportees = sessionStorage.getItem('Reportees') || '';
    this.userId = sessionStorage.getItem('userId') || '';

    this.companyId = sessionStorage.getItem('companyId') || '';
    this.companyName = sessionStorage.getItem('CompanyName') || '';

    this.IsGuestAdmin = sessionStorage.getItem('IsGuestAdmin') === 'true';

    const loginFlag = sessionStorage.getItem('LoginFlag');

    // 🔐 Role flags
    const roleFlags = sessionStorage.getItem('rolesFlags');
    if (roleFlags) {
      const flags = JSON.parse(roleFlags);

      this.hasHRProfile = flags.hasHRProfile;
      this.hasBUHR = !!flags.hasBUHR;
      this.hasAccounts = flags.hasAccounts;
      this.hasFinance = flags.hasFinance;
      this.hasCFO = flags.hasCFO;
      this.hasTravelDesk = flags.hasTravelDesk;
      this.hasBUHead = flags.hasBUHead;
      this.hasRDH = flags.hasRDH;
      this.hasGDH = flags.hasGDH;
      this.hasGuestAdmin = flags.hasGuestAdmin;
      this.hasKOCKPIT = flags.hasKOCKPIT;
    }

    if (sessionStorage.getItem('ISBUHR') === '1') {
      this.hasBUHR = true;
    }

    this.updateCanManageRsmMaster();

    // Navbar visibility
    if (loginFlag === '1') {
      if (this.companyId === 'THR') {
        this.showNavTHR = true;
        this.ShowNavBar = false;
      } else {
        this.ShowNavBar = true;
        this.showNavTHR = false;
      }
    } else {
      this.resetNavbar();
    }

    if (this.userId) {
      this.MenuHide = !this.userId.includes('TA');
    }

    this.hasDriverManagerInbox = this._sharedSer.isDriverManagerApprovalUser(this.userId);
  }

  /** RSM Master menu: TMC 16268 always, OR (HRPROFILE/BUHR + SBU 500). */
  updateCanManageRsmMaster(): void {
    const tmc = (this.userId || sessionStorage.getItem('userId') || '').toString().trim();
    const sbu = (sessionStorage.getItem('UserSBUCode') || '').toString().trim();
    const hasHrRole = this.hasHRProfile || this.hasBUHR;
    this.canManageRsmMaster =
      tmc === this.rsmMasterAllowedTmc ||
      (hasHrRole && sbu === this.rsmMasterAllowedSbu);
  }

  /** Driver Reimbursement self menus (Request/Status) — G bands or TMC 16268. */
  get canSeeDriverSelfMenu(): boolean {
    const tmc = (this.userId || '').toString().trim();
    return this.Band === 'G1' || this.Band === 'G2' || this.Band === 'G3' || this.Band === 'G4'
      || tmc === this.rsmMasterAllowedTmc;
  }

  /** Full Driver Reimbursement nav (self + accounts + manager). */
  get canSeeDriverModule(): boolean {
    return this.canSeeDriverSelfMenu || this.hasAccounts || this.hasDriverManagerInbox;
  }



  resetNavbar(): void {
    this.ShowNavBar = false;
    this.showNavTHR = false;
    this.hasHRProfile = false;
    this.hasBUHR = false;
    this.hasAccounts = false;
    this.hasFinance = false;
    this.hasCFO = false;
    this.hasDriverManagerInbox = false;
    this.hasTravelDesk = false;
    this.hasBUHead = false;
    this.hasRDH = false;
    this.hasGDH = false;
    this.hasGuestAdmin = false;
    this.hasKOCKPIT = false;
    this.canManageRsmMaster = false;
  }

  // ================= VERSION CHECK =================
  getCurrentVersion(): void {
    this.subscription = this._sharedSer.getCurrentVersion().subscribe((x: any) => {
      if (!x || !x.Data || !x.Data.length) {
        return;
      }

      const ver = parseInt(x.Data[0].CURRENT_VERSION, 10);

      if (this.version !== ver) {
        this.version = ver;
        localStorage.setItem('appversion', ver.toString());
      }
    });
  }

  // ================= UTIL =================
  shortName(fullName: string): string {
    if (!fullName) return '';
    return fullName
      .split(' ')
      .map(x => x.charAt(0))
      .join('')
      .toUpperCase();
  }

  toggleUserMenu(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clearUserMenuHoverTimer();
    this.userMenuOpen = !this.userMenuOpen;
    if (this.userMenuOpen) {
      this.closeMobileNavDropdowns();
    }
  }

  openUserMenuOnHover(): void {
    if (window.innerWidth < 992) {
      return;
    }
    this.clearUserMenuHoverTimer();
    this.userMenuOpen = true;
    this.closeMobileNavDropdowns();
  }

  closeUserMenuOnHover(): void {
    if (window.innerWidth < 992) {
      return;
    }
    this.clearUserMenuHoverTimer();
    this.userMenuHoverCloseTimer = setTimeout(() => {
      this.userMenuOpen = false;
      this.userMenuHoverCloseTimer = null;
    }, 120);
  }

  closeUserMenu(): void {
    this.clearUserMenuHoverTimer();
    this.userMenuOpen = false;
  }

  private clearUserMenuHoverTimer(): void {
    if (this.userMenuHoverCloseTimer) {
      clearTimeout(this.userMenuHoverCloseTimer);
      this.userMenuHoverCloseTimer = null;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('#top-noti-user')) {
      this.closeUserMenu();
    }
  }

  onMobileNavClick(event: Event): void {
    if (window.innerWidth >= 992) {
      return;
    }

    const target = event.target as HTMLElement;
    const toggle = target.closest('a.dropdown-toggle') as HTMLAnchorElement | null;

    if (toggle && toggle.closest('.team-navbar-nav')) {
      event.preventDefault();
      event.stopPropagation();

      const currentDropdown = toggle.closest('.team-nav-dropdown') as HTMLElement | null;
      const wasOpen = !!(currentDropdown && currentDropdown.classList.contains('show'));
      const nav = toggle.closest('.team-navbar-nav');

      if (nav) {
        nav.querySelectorAll('.team-nav-dropdown.show').forEach((el) => {
          el.classList.remove('show');
          const menu = el.querySelector('.dropdown-menu');
          if (menu) {
            menu.classList.remove('show');
          }
          const parentToggle = el.querySelector('.dropdown-toggle');
          if (parentToggle) {
            parentToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (currentDropdown && !wasOpen) {
        currentDropdown.classList.add('show');
        toggle.setAttribute('aria-expanded', 'true');
        const menu = currentDropdown.querySelector('.dropdown-menu');
        if (menu) {
          menu.classList.add('show');
        }
      }
      return;
    }

    const link = target.closest('a');
    if (!link || link.classList.contains('dropdown-toggle')) {
      return;
    }
    if (link.classList.contains('team-dropdown-item') || link.classList.contains('team-nav-link')) {
      this.closeMobileNavDropdowns();
      this.closeMobileMenu();
    }
  }

  closeMobileNavDropdowns(): void {
    document.querySelectorAll('.team-navbar-nav .team-nav-dropdown.show').forEach((el) => {
      el.classList.remove('show');
      const menu = el.querySelector('.dropdown-menu');
      if (menu) {
        menu.classList.remove('show');
      }
      const toggle = el.querySelector('.dropdown-toggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  closeMobileMenu(): void {
    this.closeUserMenu();
    if (window.innerWidth >= 992) {
      return;
    }
    this.closeMobileNavDropdowns();
    const win = window as any;
    if (win.$ && win.$.fn && win.$.fn.collapse) {
      win.$('#navbarNavDropdown').collapse('hide');
      return;
    }
    const collapse = document.getElementById('navbarNavDropdown');
    const toggler = document.getElementById('expandBtn') || document.getElementById('expandBtn1');
    if (collapse) {
      collapse.classList.remove('show');
    }
    if (toggler) {
      toggler.setAttribute('aria-expanded', 'false');
      toggler.classList.add('collapsed');
    }
  }

  // ================= LOGOUT =================
  Logout(): void {
    this.closeUserMenu();
    this.closeMobileNavDropdowns();
    this.closeMobileMenu();
    localStorage.setItem('logout', 'true');
    sessionStorage.clear();
    localStorage.clear();
    this._sharedSer.setUserData(null);
    this.resetNavbar();
    this._router.navigate(['']);
  }

  ngOnDestroy(): void {
    this.clearUserMenuHoverTimer();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.navCloseSubscription) {
      this.navCloseSubscription.unsubscribe();
    }
  }
}
